import {
  MdBusiness,
  MdConstruction,
  MdEventAvailable,
  MdHomeWork,
  MdOutlineAssignment,
  MdOutlineCameraAlt,
  MdOutlineLock,
  MdOutlineSecurity,
  MdOutlineShoppingCart,
  MdPrecisionManufacturing,
} from "react-icons/md";
import { industries, services } from "../ones/RunzeweContent";

const serviceIcons = [
  <MdOutlineSecurity />,
  <MdOutlineLock />,
  <MdOutlineCameraAlt />,
  <MdEventAvailable />,
  <MdOutlineAssignment />,
  <MdOutlineLock />,
];

const industryIcons = [
  <MdBusiness />,
  <MdOutlineShoppingCart />,
  <MdPrecisionManufacturing />,
  <MdHomeWork />,
  <MdConstruction />,
  <MdEventAvailable />,
];

export default function HomeServices() {
  return (
    <>
      <section className="home-services-section">
        <div className="container">
          <p className="section-kicker" data-aos="fade-up">Our Services</p>
          <div className="home-services-grid">
            {services.map((service, index) => (
              <div className="home-service-item" key={service.title} data-aos="fade-up" data-aos-delay={(index % 3) * 70}>
                <div className="home-service-icon">{serviceIcons[index]}</div>
                <h3>{service.title}</h3>
                <p>{service.short}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="industry-section">
        <div className="container">
          <p className="section-kicker" data-aos="fade-up">Trusted by Diverse Industries</p>
          <div className="industry-grid">
            {industries.map((industry, index) => (
              <div className="industry-card" key={industry.title} data-aos="zoom-in" data-aos-delay={(index % 3) * 70}>
                <img src={industry.image} alt={industry.title} />
                <div className="industry-icon">{industryIcons[index]}</div>
                <h3>{industry.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
